import { createFileRoute } from '@tanstack/react-router';
import { WeeklyTimesheetGrid } from '@/features/timesheet/WeeklyGrid';

export const Route = createFileRoute('/_app/timesheet/')({ component: WeeklyTimesheetGrid });
